import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config, user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import IssuerBankFilter from '../../filters/IssuerBankFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
class TxnSummaryReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            issuerBankIds:'',
            acqBankIds:'',
            is_aggr:1,
            ciutidIds: '',
            store_filter: true,
            show_acq_issuer:true,
            selected_tab:'Acquirer/Issuer Wise Txn Summary'
        }

    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'acquirer_summary_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {

    }
    componentDidMount() {
        if(this.state.selected_tab==='STORE Wise Summary Report'){
        this.setState({
            show_acq_issuer: false,
            selected_tab: this.state.selected_tab
        })
        }
        else {
            this.setState({
                show_acq_issuer: true,
                selected_tab: this.state.selected_tab
            })
        }
        this.get_acqissuer_txn_summary(this.state.object_type,this.state.object_code,'','');
        this.get_nfc_txn_summary(this.state.object_type,this.state.object_code,'','');
        this.get_upi_txn_summary(this.state.object_type,this.state.object_code,'','');
        this.get_eft_txn_summary(this.state.object_type,this.state.object_code,'','');
        this.get_storewise_summary_report(this.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'txn_summary_report','sparcs')
    }

    get_all_txn_summary(object_type, object_code, selected_tab, event){
    if(selected_tab==='STORE Wise Summary Report'){
        this.setState({
            show_acq_issuer: false,
            selected_tab: selected_tab
        })
    }
    else {
        this.setState({
            show_acq_issuer: true,
            selected_tab: selected_tab
        })
    }
        setTimeout(function(){
            this.get_acqissuer_txn_summary(object_type, object_code, event);
            this.get_nfc_txn_summary(object_type, object_code, event);
            this.get_upi_txn_summary(object_type, object_code, event);
            this.get_eft_txn_summary(object_type, object_code, event);
            this.get_storewise_summary_report(object_type,object_code,event)
        }.bind(this), 200);


    }
    get_acqissuer_txn_summary(object_type, object_code, event) {
        var that = this;

        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            issuer: this.state.issuerBankIds,
            yestSend: this.state.yestSend,
            bids: this.state.acqBankIds,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
        };
        if ($.fn.DataTable.isDataTable('#AcqIssuerSummaryTable')) {
            $('#AcqIssuerSummaryTable').DataTable().clear().destroy();
        }
        var AcqIssuerSummaryTable = $('#AcqIssuerSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/acq-issuer-txn-summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"merchant_name" },
                    {"data":"chain_name"},
                    {"data": "store_name"},
                    {"data":"acq_bank_name"},
                    {"data":"issuing_bank_name"},
                    // {"data": "transaction_date"},
                    {"data": "card_type"},
                    {"data": "card_network"},
                    {"data": "total_txncount"},
                    {"data": "total_amount"},
                    {"data": "count_upto_2000"},
                    {"data": "amout_upto_2000"},
                    {"data": "count_from_2000to3000"},
                    {"data": "amount_from_2000to3000"},
                    {"data": "count_from_3000to5000"},
                    {"data": "amount_from_3000to5000"},
                    {"data": "count_grater_then_5000"},
                    {"data": "amount_grater_then_5000"},
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
                        "className": "text-right"
                    },

                ],
            });
    }
    get_nfc_txn_summary(object_type, object_code, event) {
        var that = this;


        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            issuer: this.state.issuerBankIds,
            yestSend: this.state.yestSend,
            bids: this.state.acqBankIds,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
        };
        if ($.fn.DataTable.isDataTable('#NfcSummaryTable')) {
            $('#NfcSummaryTable').DataTable().clear().destroy();
        }
        var NfcSummaryTable = $('#NfcSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/nfc-txn-summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"merchant_name" },
                    {"data":"chain_name"},
                    {"data": "store_name"},
                    {"data":"acq_bank_name"},
                    {"data":"issuing_bank_name"},
                    // {"data": "transaction_date"},
                    {"data": "card_type"},
                    {"data": "card_network"},
                    {"data": "total_txncount"},
                    {"data": "total_amount"},
                    {"data": "count_upto_2000"},
                    {"data": "amout_upto_2000"},
                    {"data": "count_from_2000to3000"},
                    {"data": "amount_from_2000to3000"},
                    {"data": "count_from_3000to5000"},
                    {"data": "amount_from_3000to5000"},
                    {"data": "count_grater_then_5000"},
                    {"data": "amount_grater_then_5000"},
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
                        "className": "text-right"
                    },

                ],
            });
    }
    get_upi_txn_summary(object_type, object_code, event) {
        var that = this;

        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            issuer: this.state.issuerBankIds,
            yestSend: this.state.yestSend,
            bids: this.state.acqBankIds,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
        };
        if ($.fn.DataTable.isDataTable('#UpiSummaryTable')) {
            $('#UpiSummaryTable').DataTable().clear().destroy();
        }
        var UpiSummaryTable = $('#UpiSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/upi-txn-summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"merchant_name" },
                    {"data":"chain_name"},
                    {"data": "store_name"},
                    {"data":"acq_bank_name"},
                    {"data":"issuing_bank_name"},

                    {"data": "total_txncount"},
                    {"data": "total_amount"},
                    {"data": "count_upto_2000"},
                    {"data": "amout_upto_2000"},
                    {"data": "count_from_2000to3000"},
                    {"data": "amount_from_2000to3000"},
                    {"data": "count_from_3000to5000"},
                    {"data": "amount_from_3000to5000"},
                    {"data": "count_grater_then_5000"},
                    {"data": "amount_grater_then_5000"},
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        "className": "text-right"
                    },

                ],
            });
    }
    get_eft_txn_summary(object_type, object_code, event) {
        var that = this;

        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            issuer: this.state.issuerBankIds,
            yestSend: this.state.yestSend,
            bids: this.state.acqBankIds,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
        };
        if ($.fn.DataTable.isDataTable('#EFTSummaryTable')) {
            $('#EFTSummaryTable').DataTable().clear().destroy();
        }
        var EFTSummaryTable = $('#EFTSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/eft-txn-summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"merchant_name" },
                    {"data":"chain_name"},
                    {"data": "store_name"},
                    {"data":"acq_bank_name"},
                    {"data":"issuing_bank_name"},
                    // {"data": "transaction_date"},
                    {"data": "card_type"},
                    {"data": "card_network"},
                    {"data": "total_txncount"},
                    {"data": "total_amount"},
                    {"data": "count_upto_2000"},
                    {"data": "amout_upto_2000"},
                    {"data": "count_from_2000to3000"},
                    {"data": "amount_from_2000to3000"},
                    {"data": "count_from_3000to5000"},
                    {"data": "amount_from_3000to5000"},
                    {"data": "count_grater_then_5000"},
                    {"data": "amount_grater_then_5000"},
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                        "className": "text-right"
                    },

                ],
            });
    }

    get_storewise_summary_report(object_type, object_code, event) {
        var that = this;

        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            issuer: this.state.issuerBankIds,
            yestSend: this.state.yestSend,
            bids: this.state.acqBankIds,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
        };
        if ($.fn.DataTable.isDataTable('#STORESummaryTable')) {
            $('#STORESummaryTable').DataTable().clear().destroy();
        }
        var STORESummaryTable = $('#STORESummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/store_wise_summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"merchant_name" },
                    {"data":"chain_name"},
                    {"data": "store_name"},
                    {"data":"EFT_tot_count"},
                    {"data": "EFT_tot_amount"},
                    {"data":"UPI_tot_count"},
                    {"data":"UPI_tot_amount"},
                    {"data":"Total_Count"},
                    {"data":"Total Amount"},

                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "className": "text-right"
                    },

                ],
            });
    }

    txnSummaryDownloadCheck(type, e){
    var filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            issuing_bank_name: this.state.issuerBankIds,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            aggregate: this.state.is_aggr,
            download: 1,
            utids: this.state.ciutidIds,
            card_network:""
        };
        var fn = ''; var url = '';
        if(type==='acc_issuer'){
            fn='Acquirer_Issuer_Wise_Txn_Summary.csv.gz';
            url = '/summary_reports/acquirer/issuer/summary';
        }
        if(type==='nfc'){
            fn='NFC_Txn_Summary.csv.gz';
            url = '/summary_reports/nfc/transaction/summary';
        }
        if(type==='upi'){
            fn='UPI_Txn_Summary.csv.gz';
            url = '/summary_reports/upi/summary';
        }
        if(type==='eft'){
            fn='EFT_Txn_Summary.csv.gz';
            url = '/summary_reports/eft/transaction/summary';
        }
        if(type==='store'){
            fn='STORE_wise_Txn_Summary.csv.gz';
            url = '/summary_reports/store/wise/summary';
        }


    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.acqBankIds==='' && this.state.issuerBankIds===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.refs.downloadAllReport.downLoadReport(filters, url, fn, 30);
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, url, fn, 30);
        }
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            //this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            //this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
           // this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            //this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        if(this.state.selected_tab!=='STORE Wise Summary Report') {
            this.refs.issuerBankFilter.resetIssuerBankFilter();
            this.refs.acquirerFilter.resetAcquirerFilter();
        }

        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            issuerBankIds:'',
            acqBankIds:'',
            ciutidIds: '',
            isChange: false,
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        //this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        //this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        //this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }
    handleIssuerBank = (optionSelected, issuerArray) =>
    {
        this.setState({
            issuerBankIds:issuerArray,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }

    render() {

        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Txn Summary Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            {this.state.show_acq_issuer==true ?
                                                <>
                                                    <div className="col-md-2 filter-bottom5 padd-5">
                                                        <label>Acquirer:</label>
                                                        <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                        <div className="clearfix"></div>
                                                    </div>

                                                    <div className="col-md-2 filter-bottom5 padd-5">
                                                        <label>Issuer:</label>
                                                        <IssuerBankFilter ref="issuerBankFilter" onSelectIssuerBank = {this.handleIssuerBank}/>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </>
                                            :
                                            null
                                        }

                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                        <button id='apply_btn' type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_all_txn_summary.bind(this, this.state.object_type,this.state.object_code, this.state.selected_tab)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">


                                        <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'Acquirer/Issuer Wise Txn Summary','')}>Acquirer/Issuer Wise Txn Summary</Tab>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'NFC Txn Summary','')}>NFC Txn Summary</Tab>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'UPI Txn Summary','')}>UPI Txn Summary</Tab>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'EFT Txn Summary','')}>EFT Txn Summary</Tab>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'STORE Wise Summary Report','')}>STORE Wise Summary Report</Tab>
                                        </TabList>

                                        <TabPanel>

                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.txnSummaryDownloadCheck.bind(this,'acc_issuer')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="AcqIssuerSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Merchant</th>
                                                    <th>Chain</th>
                                                    <th>Store Name</th>
                                                    <th>Acquirer Bank</th>
                                                    <th>Issuing Bank</th>
                                                    <th>Card Type</th>
                                                    <th>Card Network</th>
                                                    <th>Total Count</th>
                                                    <th>Total Amount</th>
                                                    <th>Count UpTo 2000</th>
                                                    <th>Amount UpTo 2000</th>
                                                    <th>Count From 2000 to 3000</th>
                                                    <th>Amount From 2000 to 3000</th>
                                                    <th>Count From 3000 to 5000</th>
                                                    <th>Amount From 3000 to 5000</th>
                                                    <th>Count Grater Than 5000</th>
                                                    <th>Amount Grater Than 5000</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                        </div>

                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.txnSummaryDownloadCheck.bind(this,'nfc')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="NfcSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store Name</th>
                                                <th>Acquirer Bank</th>
                                                <th>Issuing Bank</th>
                                                <th>Card Type</th>
                                                <th>Card Network</th>
                                                <th>Total Count</th>
                                                <th>Total Amount</th>
                                                <th>Count UpTo 2000</th>
                                                <th>Amount UpTo 2000</th>
                                                <th>Count From 2000 to 3000</th>
                                                <th>Amount From 2000 to 3000</th>
                                                <th>Count From 3000 to 5000</th>
                                                <th>Amount From 3000 to 5000</th>
                                                <th>Count Grater Than 5000</th>
                                                <th>Amount Grater Than 5000</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.txnSummaryDownloadCheck.bind(this,'upi')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="UpiSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store Name</th>
                                                <th>Acquirer Bank</th>
                                                <th>Issuing Bank</th>

                                                <th>Total Count</th>
                                                <th>Total Amount</th>
                                                <th>Count UpTo 2000</th>
                                                <th>Amount UpTo 2000</th>
                                                <th>Count From 2000 to 3000</th>
                                                <th>Amount From 2000 to 3000</th>
                                                <th>Count From 3000 to 5000</th>
                                                <th>Amount From 3000 to 5000</th>
                                                <th>Count Grater Than 5000</th>
                                                <th>Amount Grater Than 5000</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.txnSummaryDownloadCheck.bind(this,'eft')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="EFTSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store Name</th>
                                                <th>Acquirer Bank</th>
                                                <th>Issuing Bank</th>
                                                <th>Card Type</th>
                                                <th>Card Network</th>
                                                <th>Total Count</th>
                                                <th>Total Amount</th>
                                                <th>Count UpTo 2000</th>
                                                <th>Amount UpTo 2000</th>
                                                <th>Count From 2000 to 3000</th>
                                                <th>Amount From 2000 to 3000</th>
                                                <th>Count From 3000 to 5000</th>
                                                <th>Amount From 3000 to 5000</th>
                                                <th>Count Grater Than 5000</th>
                                                <th>Amount Grater Than 5000</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.txnSummaryDownloadCheck.bind(this,'store')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="STORESummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store Name</th>
                                                <th>EFT Total Count</th>
                                                <th>EFT Total Amount</th>
                                                <th>UPI Total Count</th>
                                                <th>UPI Total Amount</th>
                                                <th>Total Count</th>
                                                <th>Total Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>
                                        </Tabs>
                                        <div className="clearfix"></div>

                                    </div>

                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( TxnSummaryReport);